/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lower_Proud_Turtle_AnimateInputs */

const fr_lower_proud_turtle_animate = /** @type {(inputs: Lower_Proud_Turtle_AnimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

/**

* @param {Lower_Proud_Turtle_AnimateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lower_proud_turtle_animate = /** @type {((inputs?: Lower_Proud_Turtle_AnimateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lower_Proud_Turtle_AnimateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lower_proud_turtle_animate(inputs)
});